

<footer class="dark f-height text-smf footer">
  <div class="col-md-12 p-0">
    <div [ngClass]="{'disabled': clientInstructionRestriction == true}" class="menu-icon"  (click)="ToggleMenu()">
      <span class="footer-i">
        <i class="fa fa-bars ft-22 menu-i" aria-hidden="true"></i>
      </span>
    </div>
    <div class="footer-copytext">
      <div class="text-right">Copyright © {{CurrentYear}}. Powered by GeBBS</div>
    </div>
  </div>
</footer>
